import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import RecomendationsToc from "./returnPage/components/RecomendationsToc";
import InvalidLink from "./returnPage/components/InvalidLink";
import { useDispatchDigitalTransfersContext } from "../../context/DigitalTransfersContext";
import { ReturnStep2 } from "./ReturnStep2";
import { useCatchFetch } from "../../hooks/useCatchFetch";
import { validateIdProspect, validateSession, checkTocAttempts } from "../../services";
import { MainContainer } from "../../components/MainContainer";
import { ContinueFlow } from '../../../funnel-continue-flow';
import { sendToData } from '../../constants/sendToDataLayer';
import { Header } from '../../../App/pages/layout-sin-asesor/Layout/header';

const useQuery = () => new URLSearchParams(useLocation().search);

const Loading = () => <div>Cargando...</div>;

export const ReturnFlow = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [step, setStep] = useState(0);
  const [renderMiniLanding, setRenderMiniLanding] = useState(false);

  const query = useQuery();
  const idProspect = query.get('idProspect');
  const history = useHistory();
  const dispatch = useDispatchDigitalTransfersContext();
  const { SendFetch, TransparentSendFetch, SetLoading } = useCatchFetch();

  useEffect(() => {
    const canonicalHref = `${process.env.REACT_APP_BASE_URL_TRASPASO}/traspasos/continuar-traspaso`;
    if (!document.querySelector(`head link[href="${canonicalHref}"]`)) {
      const newLink = document.createElement("link");
      newLink.rel = "canonical";
      newLink.href = canonicalHref;
      document.head.appendChild(newLink);
    }
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      const meta = document.createElement("meta");
      meta.name = "robots";
      meta.content = "noindex, nofollow";
      document.head.appendChild(meta);
    } else {
      metaRobots.setAttribute("content", "noindex, nofollow");
    }
  }, []);


  useEffect(() => {
    sessionStorage.setItem("timestampFirstQuery", Date.now());
    sessionStorage.setItem("flagReturnFlow", 'RETORNO');

    const timer = setTimeout(() => setIsLoading(false), 3000);
    fetchInitialData();
    return () => clearTimeout(timer);
  }, []);

  const dispatchValidUser = (res) => {
    dispatch({
      type: "VALID_DOCUMENT",
      payload: {
        userWebTransfer: { documentNumber: res.documentNumber, firstName: res.name, age: res.age },
        userWeb: { documentNumber: res.documentNumber, firstName: res.name, age: res.age, address: res.address },
        validReniec: true,
        isAddressDNI: true,
        validReniecActive: true,
        changeLoading: false,
        enabledAbandonmentStep1: true,
      },
    });
  };

  const dispatchInvalid = (message = '', dni='') => {
    var payload = {
      section: "paso 0",
      option: message === '' ? 'Hubo un error en la consulta' : message,
      dni: dni,
    };
    const currentUrl = window.location.href;
    dispatch({
      type: "FIELD",
      payload: { field: "urlFlow", value: currentUrl },
    });
    sendToData(window.location.href, 'step', "error", payload, currentUrl, 'traspasos digitales_continuar-traspaso');
    dispatch({
      type: "NOT_VALID_DOCUMENT",
      payload: {
        idModal: "btn-error-documentIdentity",
        changeLoading: false,
        className: "centerContent",
        returnStep: "STEP_0",
        content: message,
      },
    });
  };

  const checkTOCActive = async (documentNumber) => {
    try {
      return await TransparentSendFetch(checkTocAttempts(documentNumber));
    } catch (e) {
      console.log("error", e);
    }
  };

  const handleResponse = async (res, dni='') => {
    if (res.code === 1) {
      await checkTOCActive(res.documentNumber);
      setStep(res.step);
      dispatchValidUser(res);
      var payload = {
        count_1_1: '1',
        dni: res.documentNumber,
        edad: res.age,
        telefono: res.phone,
        section: "paso_1_continuar-traspaso",
        option: "siguiente"
      };
      const currentUrl = window.location.href;
      dispatch({
        type: "FIELD",
        payload: { field: "urlFlow", value: currentUrl },
      });
      sendToData(window.location.href, 'step', "paso_1_continuar-traspaso", payload, currentUrl, 'traspasos digitales_continuar-traspaso');
      dispatch({ type: "FIELD", payload: { field: "stepCurrent", value: res.step } });
      if (res.step === 0) {
        const utmParams = currentUrl.split('?')[1]; 
        const redirectUrl = utmParams ? `/pasos0?${utmParams}` : '/pasos0'; 
        history.push(redirectUrl); 
      }
    } else if ([2, 3, 5].includes(res.code)) {
      dispatchInvalid(res.message, dni);
    } else if (res.code === 4 || res.code === -1) {
      setStep(-1);
    }
  };

  const fetchInitialData = async () => {
    if (!idProspect) {
      setRenderMiniLanding(true);
      return;
    }

    SetLoading(true);
    try {
      const res = await SendFetch(validateIdProspect({ idProspect }));
      await handleResponse(res);
    } catch (e) {
      console.log('error en retorno', e);
      dispatchInvalid();
    }
  };

  const handleClick = async (dni, recaptchaToken) => {
    SetLoading(true);
    setRenderMiniLanding(false);
    try {
      var payload = { section: "paso_1_continuar-traspaso", option: "siguiente" };
      sendToData(window.location.href, "button_click", "button_click", payload);
      const res = await SendFetch(validateSession({ documentNumber: dni, recaptchaToken }));
      await handleResponse(res, dni);
    } catch (e) {
      console.log('error en retorno', e);
      dispatchInvalid('Hubo un error en la consulta', dni);
    }
  };

  if (isLoading) return <Loading />;
  if (renderMiniLanding) return (
    <> <Header /> <ContinueFlow onHandleClick={handleClick} /></>
  );

  if (step === 2) return <ReturnStep2 />;
  if (step === 3) return <RecomendationsToc />;
  if (step === -1) return <InvalidLink />;

  return (
    <div>
      <MainContainer id="idMainContainer" />
    </div>
  );
};